export const removeNodeRole = (id, role) => ({
    type: "JOINT.ROLES.REMOVE",
    payload: { id, role },
});
